import { graphql, useStaticQuery } from "gatsby"

export const UseVideoLinks = () => {
    const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
            edge_Cloud_Short_Demo
            edge_Imaging_Demo
            online_Scheduling_Demo
            edge_Proposal_Demo
            edge_Specialist_Demo
            edge_Animations_Demo
          }
      }
    }
  `)

    return data.site.siteMetadata
}